/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from "@glimmer/component";
import type { TreatmentSectionWithColor } from "parog-web/models/base-treatment-filled-journal-event";
import type BaseTreatmentFilledJournalEvent from "parog-web/models/base-treatment-filled-journal-event";
import type Patient from "parog-web/models/patient";

import { service } from "@ember/service";
import type SemeiaSessionService from "parog-web/services/session";
import { sortBy } from "parog-web/utils/sort";

interface Signature {
  Args: {
    isLoading?: unknown;
    hideAction?: unknown;
    patient: Patient;
    journalEvents: BaseTreatmentFilledJournalEvent[];
    answersGroupedBySection: Record<string, TreatmentSectionWithColor[]>;
    title: string;
    feature: string;
    component: string;
  };
}

export default class extends Component<Signature> {
  @service declare session: SemeiaSessionService;

  get journalEvents(): BaseTreatmentFilledJournalEvent[] {
    return this.args.journalEvents.sort(sortBy("occurredAt", "desc")) || [];
  }

  get answersGroupedBySection(): Record<string, TreatmentSectionWithColor> {
    return this.args.journalEvents.reduce(
      (acc, curr: BaseTreatmentFilledJournalEvent) => {
        curr.sectionsWithColor.forEach(section => {
          if (!acc.hasOwnProperty(section.key)) {
            acc[section.key] = [];
          }
          acc[section.key].push(section);
        });

        return acc;
      },
      {}
    );
  }
}
